import { combineReducers } from 'redux'
import {
  LIKE_REVIEW,
  UNLIKE_REVIEW,
  FETCHING_REVIEWS_AMBASSADOR_INITIAL,
  FETCHING_REVIEWS_AMBASSADOR_MORE,
  RECEIVED_REVIEWS_AMBASSADOR_INITIAL,
  RECEIVED_REVIEWS_AMBASSADOR_MORE,
  ERROR_FETCHING_REVIEWS_AMBASSADOR_INITIAL,
  ERROR_FETCHING_REVIEWS_AMBASSADOR_MORE
} from '../actions/constants/reviews'
import * as types from '../constants/actionTypes'

// TODO fix
// eslint-disable-next-line complexity,sonarjs/cognitive-complexity
const all = (state = {}, action) => {
  let review

  switch (action.type) {
    case RECEIVED_REVIEWS_AMBASSADOR_INITIAL:
    case RECEIVED_REVIEWS_AMBASSADOR_MORE:
      return {
        ...state,
        ...action.data.reduce((obj, r) => {
          const objCopy = { ...obj }
          objCopy[r._id] = { ...r, comment: '' }
          return objCopy
        }, {})
      }
    case LIKE_REVIEW:
      review = state[action.reviewID]
      return {
        ...state,
        [action.reviewID]: {
          ...review,
          isLiked: true,
          likesCount: (review?.likesCount ?? 0) + 1
        }
      }
    case UNLIKE_REVIEW:
      review = state[action.reviewID]
      return {
        ...state,
        [action.reviewID]: {
          ...review,
          isLiked: false,
          likesCount: (review?.likesCount ?? 0) - 1
        }
      }
    case types.LIKING_COMMENT: {
      const { commentID, reviewID, viewerID } = action
      review = state[reviewID]
      const comment = review.comments.find((c) => c._id === commentID)

      const updatedComment = {
        ...comment,
        likes: comment.likes
          ? comment.likes.filter((u) => u !== viewerID).concat(viewerID)
          : [viewerID]
      }

      const updatedComments = review.comments.map((c) =>
        c._id === commentID ? updatedComment : c
      )

      const updatedReview = {
        ...review,
        comments: updatedComments
      }
      return {
        ...state,
        [reviewID]: updatedReview
      }
    }
    case types.UNLIKING_COMMENT: {
      const { commentID, reviewID, viewerID } = action
      review = state[reviewID]

      const comment = review.comments.find((c) => c._id === commentID)

      const updatedComment = {
        ...comment,
        likes: comment.likes.filter((u) => u !== viewerID)
      }

      const updatedComments = review.comments.map((c) =>
        c._id === commentID ? updatedComment : c
      )

      const updatedReview = {
        ...review,
        comments: updatedComments
      }

      return {
        ...state,
        [reviewID]: updatedReview
      }
    }
    case types.UPDATED_REVIEWS:
      return {
        ...state,
        [action._id]: { ...state[action._id], ...action.value }
      }
    default:
      return state
  }
}

// TODO fix
// eslint-disable-next-line complexity
const ambassador = (
  state = {
    isLoading: false,
    error: false,
    fetched: false,
    items: [],
    skip: 0,
    limit: 10,
    hasMore: true
  },
  action
) => {
  switch (action.type) {
    case FETCHING_REVIEWS_AMBASSADOR_INITIAL:
      return {
        ...state,
        isLoading: true,
        error: false,
        items: []
      }
    case FETCHING_REVIEWS_AMBASSADOR_MORE:
      return {
        ...state,
        isLoading: true,
        error: false
      }
    case RECEIVED_REVIEWS_AMBASSADOR_INITIAL:
      return {
        ...state,
        isLoading: false,
        error: false,
        fetched: true,
        items: action.data.map((review) => review._id),
        // items: [],
        skip: state.limit,
        hasMore: action.data.length === state.limit
        // hasMore: false
      }
    case RECEIVED_REVIEWS_AMBASSADOR_MORE:
      return {
        ...state,
        isLoading: false,
        error: false,
        items: state.items.concat(
          action.data
            .filter((r) => !state.items.includes(r._id))
            .map((review) => review._id)
        ),
        skip: state.skip + state.limit,
        hasMore: action.data.length === state.limit
      }
    case ERROR_FETCHING_REVIEWS_AMBASSADOR_INITIAL:
    case ERROR_FETCHING_REVIEWS_AMBASSADOR_MORE:
      return {
        ...state,
        isLoading: false,
        error: true
      }
    default:
      return state
  }
}

export default combineReducers({
  all,
  ambassador
})
